import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';
import PopupModal from '../PopupModal/PopupModal.js';

var PreferredTimePopupModal = (_param)=> {
    var { className , labels , items  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "items"
    ]);
    return React.createElement(PopupModal, swcHelpers.extends({}, rest, {
        className: classnames('preferred-time-popup-modal', className),
        title: labels.title,
        showIcon: true
    }), /*#__PURE__*/ React.createElement("ul", {
        className: "preferred-time-popup-modal__list"
    }, items.map(({ option , label , active , onClick  })=>/*#__PURE__*/ React.createElement("li", {
            key: option.name,
            className: "preferred-time-popup-modal__list-item"
        }, /*#__PURE__*/ React.createElement("button", {
            className: "preferred-time-popup-modal__button",
            onClick: onClick,
            disabled: active
        }, label, active && /*#__PURE__*/ React.createElement("span", {
            className: "preferred-time-popup-modal__icon"
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "checkmark"
        }))))
    )));
};
var PreferredTimePopupModal$1 = PreferredTimePopupModal;

export { PreferredTimePopupModal, PreferredTimePopupModal$1 as default };
//# sourceMappingURL=PreferredTimePopupModal.js.map
